import React from 'react';
import LookupManager from './LookupManager';

const PulseComponent = () => {
    return (
        <LookupManager
            title="Pulse per revolution"
            endpoint="pulse"
            placeholder="Pulse value"
            loadingLabel="Loading pulse values..."
            emptyLabel="No pulse values yet."
        />
    );
};

export default PulseComponent;
